export default "__VITE_ASSET__BkBNZ5O4__"